import type { SettingsOptions } from '../common/types/general';

const reactAppVersion = process.env.REACT_APP_VERSION;

const dndSettings: SettingsOptions[] = [];

const fbSettings: SettingsOptions[] = ['advisors', 'groups'];

const fhbfSettings = (location: string): SettingsOptions[] => {
  if (location.includes('fachberatungsstelle')) {
    return ['groups'];
  }
  if (location.includes('interventionsstelle')) {
    return [];
  }

  return [];
};

const fhfSettings: SettingsOptions[] = ['advisors'];

const getSettingsOptions = (location: string): SettingsOptions[] => {
  if (reactAppVersion === 'dnd') {
    return dndSettings;
  }
  if (reactAppVersion === 'fb') {
    return fbSettings;
  }
  if (reactAppVersion === 'fhbf') {
    return fhbfSettings(location);
  }
  if (reactAppVersion === 'fhf') {
    return fhfSettings;
  }
  return [];
};

export default getSettingsOptions;
